import { render, staticRenderFns } from "./QuizNightConfiguration.vue?vue&type=template&id=2ba6ac61&scoped=true"
import script from "./QuizNightConfiguration.vue?vue&type=script&lang=js"
export * from "./QuizNightConfiguration.vue?vue&type=script&lang=js"
import style0 from "./QuizNightConfiguration.vue?vue&type=style&index=0&id=2ba6ac61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6ac61",
  null
  
)

export default component.exports